// extracted by mini-css-extract-plugin
export default {"section":"News_section__x6b43","addMore":"News_addMore__b88TG"};